import { rewriteImageSrc } from '@/utils/rewriteImageSrc';
import classnames from 'classnames';
import type { AuthorImagesElementProps } from './AuthorImages.types';

export function AuthorImagesElement(props: AuthorImagesElementProps) {
  const { element, children, attributes, className } = props;
  const { size, fill, authors } = element.attrs || {};

  return (
    <div className={classnames(className, 'relative')} {...attributes}>
      <div className="flex -space-x-1.5">
        {authors?.map((author) => {
          return (
            <div
              key={author?.id}
              className={classnames('rounded-full')}
              style={{
                width: size,
                height: size,
              }}
            >
              <img
                className={classnames('inline-block object-cover rounded-full')}
                src={rewriteImageSrc(author.profile_picture.url)}
                alt={author.name}
                style={{
                  border: `1px solid ${fill}`,
                  width: size,
                  height: size,
                }}
              />
            </div>
          );
        })}
      </div>
      {children}
    </div>
  );
}
